import styled from "styled-components";

const StyledTFoot = styled.tfoot`
  font-size: 14px;
  font-weight: 500;
  margin-top: 12px;
  tr {
    .total-text {
      text-align: center;
      padding: 12px 10px;
    }
    .value {
      padding: 12px 10px;
      text-align: right;
      white-space: nowrap;
    }
  }
`;

const StyledDeleteRowButton = styled.button`
  background-color: transparent;
  border: none;
  padding-left: 16px;
`;

const StyledSelectProductContentDiv = styled.div`
  padding: 8px 14px;
  box-shadow:
    0 3px 6px -4px rgba(0, 0, 0, 0.12),
    0 6px 16px 0 rgba(0, 0, 0, 0.08);
`;

const StyledUl = styled.ul`
  padding: 0;
  margin: 0;
  width: 100%;
  font-size: 14px;
  max-height: 168px;
  overflow: auto;
  list-style: none;
  box-shadow:
    0 3px 6px -4px rgba(0, 0, 0, 0.12),
    0 6px 16px 0 rgba(0, 0, 0, 0.08);
`;

const StyledAddProductLi = styled.li`
  button {
    background-color: transparent;
    border: none;
    color: var(--BLUE, #2060ea);
    padding: 5px 12px;
    display: flex;
    align-items: center;
    gap: 8px;
  }
  &:hover {
    background-color: var(--MIST, #f7f8f9);
  }
`;
const StyledLi = styled.li`
  color: var(--DARK-GREY, #0e0e2c);
  font-weight: 400;
  line-height: 22px;
  padding: 5px 12px;
  cursor: pointer;
  &:hover {
    color: var(--BLUE, #2060ea);
    background-color: var(--MIST, #f7f8f9);
  }
`;

const StyledSelectProductDiv = styled.div`
  .inputValuePlace {
    display: flex;
    align-items: center;
    box-sizing: border-box;
    position: relative;
    background-color: var(--GHOST, #efeffd);
    border: none;
    border-radius: 4px;
    height: 32px;
    margin: 0;
    overflow: hidden;
    color: var(--ASH, #676879);
    text-overflow: ellipsis;
    font-weight: 400;
    line-height: 20px;
    padding: 0 10px;

    svg {
      position: absolute;
      right: 10px;
    }
    input {
      outline: none;
      width: 100%;
      border: none;
      padding-right: 18px;
      background-color: transparent;
      color: var(--DARK-BLUE, #1249bf);
      font-size: 10px;
      font-weight: 500;
    }
  }
`;

const StyledAddPOItemsDiv = styled.div`
  margin: 16px 24px;
  color: #0e0e2c;
  font-size: 16px;
  font-weight: 600;
  line-height: 120%;
  display: flex;
  gap: 16px;
  position: relative;

  .addItem {
    color: var(--BLUE, #2060ea);
    font-size: 14px;
    font-weight: 500;
    line-height: 22px;
    display: flex;
    gap: 4px;
    align-items: center;
    cursor: pointer;
  }
`;

const StyledStarSpan = styled.span`
  color: var(--DANGER, #cf324a);
`;

const SelectDropDownHeaderDiv = styled.div`
  border-radius: 4px 4px 0 0;
  border: 1px solid var(--Pearl, #ecf1f4);
  background: #f9fafd;
  color: var(--DARK-GREY, #0e0e2c);
  font-feature-settings:
    "liga" off,
    "clig" off;
  font-weight: 600;
  line-height: 24px; /* 171.429% */

  height: 48px;
  padding: 12px;
`;

const SelectProductFromDropDownDiv = styled.div`
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  max-width: 760px;

  position: absolute;
  /* padding: 4px 0; */
  border-radius: 4px;
  border: 1px solid var(--PEARL, #ecf1f4);
  background-color: #fff;
  width: 100%;
  left: 0;
  top: ${props => props.top};
  z-index: 2;
`;
export {
  SelectDropDownHeaderDiv,
  SelectProductFromDropDownDiv,
  StyledAddPOItemsDiv,
  StyledAddProductLi,
  StyledDeleteRowButton,
  StyledLi,
  StyledSelectProductContentDiv,
  StyledSelectProductDiv,
  StyledStarSpan,
  StyledTFoot,
  StyledUl,
};

export const StyledSelectTableDiv = styled.div`
  .ant-select {
    width: 100%;
    font-family: Inter;
    font-size: 10px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px; /* 142.857% */
    letter-spacing: 0.28px;

    .ant-select-selector {
      align-items: center;
      background-color: var(--GHOST, #efeffd) !important;
      border: none !important;
      border-radius: 4px !important;
      box-shadow: none !important;
      box-sizing: border-box;
      height: 32px !important;
      min-height: 32px !important;
      padding-inline: 10px !important;
      color: var(--ASH, #676879);
    }

    .ant-select-selection-item,
    .ant-select-selection-placeholder,
    .ant-select-selection-search-input {
      color: var(--ASH, #676879);
      font-size: 10px;
    }

    .ant-select-item,
    .ant-select-selection-item {
      font-size: 10px;
    }
  }
`;

export const StyledMultiSelectDiv = styled.div`
  .ant-select-multiple .ant-select-selection-item {
    background: var(--Sky, #cce5ff);
    color: var(--ASH, #676879);
    border: none;
    outline: none;
    cursor: text;
  }
`;
